import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import Editor from "../components/Editor";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { getFirebaseDocs, randomString } from '../common'
import Header from '../components/Header'
import Tabs from "../components/Tabs";
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";

const Dashboard = () => {

    const modes = ['Parent', 'Coach', 'Brain', 'Center Downloads']
    const [confirmDelete, setConfirmDelete] = useState(false)

    const [isAdding, setIsAdding] = useState(false)
    const [isAddingBrain, setIsAddingBrain] = useState(false)
    const [isAddingCenterDownload, setIsAddingCenterDownload] = useState(false)
    const [editId, setEditId] = useState('')
    const [name, setName] = useState('')
    const [pdf, setPdf] = useState('')
    const [icon, setIcon] = useState('')
    const [audio, setAudio] = useState('')

    const [bg, setBg] = useState('')
    const [textColor, setTextColor] = useState('')
    const [priority, setPriority] = useState(1)

    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState(modes[0])

    const [brainCategory, setBrainCategory] = useState('')
    const [centerDownloadCategory, setCenterDownloadCategory] = useState('')

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [excerpt, setExcerpt] = useState('')
    const [audioTitle, setAudioTitle] = useState('')

    const [video, setVideo] = useState('')
    const [thumbnail, setThumbnail] = useState('')

    const [parentsCategories, setParentsCategories] = useState([])

    const [brainActivities, setBrainActivities] = useState([])
    const [centerDownloads, setCenterDownloads] = useState([])
    const [viewingBrainStatsId, setViewingBrainStatsId] = useState('')
    const [viewingBrainStatsName, setViewingBrainStatsName] = useState('')
    const [brainWatchStats, setBrainWatchStats] = useState([])
    const userInfo = useSelector(state => state.user.user)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (brainCategory) {
            fetchBrainActivities()
        }
    }, [brainCategory])

    useEffect(() => {
        if (mode && userInfo && userInfo.role === 'admin') {
            if (mode !== 'Brain' && mode != 'Center Downloads') {
                fetchCategories()
            } else if (mode === 'Brain') {
                fetchBrainCategories()
            } else if (mode === 'Center Downloads') {
                fetchCenterDownloads()
            }
        }
    }, [mode, userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
        // fetchCategories()
    }

    const signOutUser = async () => {
        await auth.signOut();
    }


    const fetchBrainCategories = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'brain-categories'), orderBy('priority', "desc"))))
        setParentsCategories(docs)
    }

    const fetchCenterDownloads = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'center-downloads'), orderBy('priority', "desc"))))
        setParentsCategories(docs)
        setCenterDownloads(docs)
    }

    const fetchBrainActivities = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'brain-activities'), where('parentId', '==', brainCategory), orderBy('priority', "desc"))))
        setBrainActivities(docs)
    }

    const fetchCategories = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `learn-categories`), where('type', '==', mode.toLowerCase()), orderBy('priority', 'desc'))))
        setParentsCategories(docs)
    }


    const saveLearnCategory = async () => {

        if (editId) {
            await setDoc(doc(db, mode === 'Center Downloads' ? 'center-downloads' : mode === 'Brain' ? 'brain-categories' : 'learn-categories', editId), { name, icon, audio: audio || '', background: bg, textColor, type: mode.toLowerCase(), priority: parseInt(priority) })
        } else {
            await addDoc(collection(db, mode === 'Center Downloads' ? 'center-downloads' : mode === 'Brain' ? 'brain-categories' : 'learn-categories'), { name, icon, audio: audio || '', background: bg, textColor, type: mode.toLowerCase(), priority: parseInt(priority) })
        }
        setIsAdding(false)
        setEditId('')
        mode === 'Center Downloads' ? fetchCenterDownloads() : mode === 'Brain' ? fetchBrainCategories() : fetchCategories()
    }

    // brain-activities



    const deleteActivityBrain = async () => {
        if (editId) {
            if (!confirmDelete) {
                setConfirmDelete(true)
                return
            }
            await deleteDoc(doc(db, 'brain-activities', editId))
            setConfirmDelete(false)
            // window.location.reload()
            setIsAddingBrain(false)
            fetchBrainActivities()
        }
    }

    const deleteActivityCenter = async () => {
        if (editId) {
            if (!confirmDelete) {
                setConfirmDelete(true)
                return
            }
            await deleteDoc(doc(db, 'center-downloads', editId))
            setConfirmDelete(false)
            // window.location.reload()
            setIsAddingCenterDownload(false)
            fetchCenterDownloads()
        }
    }

    const saveBrainActivity = async () => {
        if (editId) {
            await setDoc(doc(db, 'brain-activities', editId), { name, audio: audio || '', parentId: brainCategory, audioTitle: audioTitle || '', excerpt, video, thumbnail, priority: parseInt(priority) })
        } else {
            await addDoc(collection(db, 'brain-activities'), { name, audio: audio || '', parentId: brainCategory, audioTitle: audioTitle || '', excerpt, video, thumbnail, priority: parseInt(priority) })
        }
        setEditId('')
        setIsAddingBrain(false)
        fetchBrainActivities()
    }

    const resetBrainStatsView = () => {
        setViewingBrainStatsId('')
        setViewingBrainStatsName('')
        setBrainWatchStats([])
    }

    const viewBrainActivityStats = async (activity) => {
        setViewingBrainStatsId(activity.id)
        setViewingBrainStatsName(activity.name || '')

        const [coachUsers, watchedDocs] = await Promise.all([
            getFirebaseDocs(await getDocs(query(collection(db, 'users'), where('role', '==', 'coach')))),
            getFirebaseDocs(await getDocs(query(collection(db, 'coach-watched-brain-video'), where('activityId', '==', activity.id)))),
        ])

        const watchedInfo = watchedDocs.map((row) => {
            const coach = coachUsers.find(user => user.id === row.coachId)
            return {
                id: row.id,
                coachName: coach ? `${coach.firstName || ''} ${coach.lastName || ''}`.trim() || coach.email || coach.id : (row.coachId || 'Unknown Coach'),
                email: coach && coach.email ? coach.email : '',
                date: row.date || ''
            }
        }).sort((a, b) => {
            if (a.date && b.date && a.date !== b.date) {
                return a.date > b.date ? -1 : 1
            }
            return a.coachName.toLowerCase() > b.coachName.toLowerCase() ? 1 : -1
        })

        setBrainWatchStats(watchedInfo)
    }

    const saveCenterDownload = async () => {

        const payload = {
            name, pdf, thumbnail, priority: parseInt(priority), parentId: centerDownloadCategory
        }

        if (editId) {
            await setDoc(doc(db, 'center-downloads', editId), payload)
        } else {
            await addDoc(collection(db, 'center-downloads'), payload)
        }
        setEditId('')
        setIsAddingCenterDownload(false)
        fetchCenterDownloads()
    }


    const renderCenterSubcategory = () =>
        isAddingCenterDownload ? <>

            <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />


            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Thumbnail</label>
            <MyDropzone storageLocation={`CenterDownloads/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'thumbnail'} image={thumbnail} updateImage={(doc) => setThumbnail(doc)} />
            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>PDF</label>
            <MyDropzone storageLocation={`CenterDownloads/${randomString()}`} allowPdf customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'pdf'} image={pdf} updateImage={(doc) => setPdf(doc)} />

            <Input bold type={'text'} errorMessage={''} errors={[]} name={'priority'} value={priority} setValue={setPriority} label={'Priority'} />


            <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                <button disabled={!name || !pdf || !priority || !parseInt(priority)} onClick={saveCenterDownload}>Save</button>
                <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAddingCenterDownload(false); setEditId('') }}>Cancel</button>
                <button disabled={!editId} style={{ backgroundColor: 'red' }} onClick={deleteActivityCenter}>{confirmDelete ? 'Confirm Delete' : 'Delete'}</button>
            </div>

        </> :
            <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button className="textButton" style={{}} onClick={() => { setCenterDownloadCategory('') }}> {'<-Back'}</button>
                    <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAddingCenterDownload(true); setEditId(''); setThumbnail(''); setName(''); setPriority(1); setPdf('') }}>+ Add New</button>
                </div>

                <h2>Center Download Files</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Priority
                            </th>
                            <th>
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {centerDownloads.filter(r => r.parentId === centerDownloadCategory).map(({ id, name, pdf, priority, thumbnail, }) => <tr key={id}>
                            <td>
                                {name}
                            </td>
                            <td>
                                {priority}
                            </td>

                            <td>
                                <div style={{ display: 'flex' }}>
                                    {/* <button className="textButton" onClick={() => navigate(`/categories?category=${id}`)}>View</button> */}
                                    <button className="textButton" onClick={() => { setIsAddingCenterDownload(true); setEditId(id); setThumbnail(thumbnail || ''); setPriority(priority); setName(name); setPdf(pdf) }}>Edit</button>
                                </div>
                            </td>

                        </tr>)}
                    </tbody>
                </table>
            </>

    return <div className="container">
        <Header />

        {!isAdding && !isAddingBrain && !isAddingCenterDownload && <Tabs tabs={modes} currentTab={mode} setCurrentTab={setMode} />}

        {

            mode === 'Center Downloads' && centerDownloadCategory ? <>
                {
                    renderCenterSubcategory()
                }
            </>
                :
                mode === 'Brain' && brainCategory ? <>


                    {isAddingBrain ? <>
                        <h2>{editId ? 'Edit' : 'Add'} a {mode} Activity</h2>
                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />


                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Video</label>
                        <MyDropzone allowVideo storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'video'} image={video} updateImage={(doc) => setVideo(doc)} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Thumbnail</label>
                        <MyDropzone storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'thumbnail'} image={thumbnail} updateImage={(doc) => setThumbnail(doc)} />


                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Excerpt</label>
                        <Editor data={excerpt} setData={setExcerpt} />

                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'priority'} value={priority} setValue={setPriority} label={'Priority'} />


                        <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                            <button disabled={!name || !video || !priority || !parseInt(priority)} onClick={saveBrainActivity}>Save</button>
                            <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAddingBrain(false); setEditId('') }}>Cancel</button>
                            <button disabled={!editId} style={{ backgroundColor: 'red' }} onClick={deleteActivityBrain}>{confirmDelete ? 'Confirm Delete' : 'Delete'}</button>
                        </div>

                    </> : viewingBrainStatsId ? <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <h2>Brain Video Watched: {viewingBrainStatsName}</h2>
                            <button className="textButton" style={{ marginLeft: 'auto' }} onClick={resetBrainStatsView}>Back</button>
                        </div>

                        <p style={{ marginTop: '10px', fontSize: '14px' }}>
                            {brainWatchStats.length} coach{brainWatchStats.length === 1 ? '' : 'es'} watched this Brain video.
                        </p>

                        <table>
                            <thead>
                                <tr>
                                    <th>Coach</th>
                                    <th>Email</th>
                                    <th>Watched At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {brainWatchStats.map(row => <tr key={row.id}>
                                    <td>{row.coachName}</td>
                                    <td>{row.email || '-'}</td>
                                    <td>{row.date ? new Date(row.date).toLocaleString() : '-'}</td>
                                </tr>)}
                                {brainWatchStats.length === 0 && <tr>
                                    <td colSpan={3}>No coaches have watched this Brain video yet.</td>
                                </tr>}
                            </tbody>
                        </table>
                    </> : <>
                        {/* <Tabs tabs={modes} currentTab={mode} setCurrentTab={setMode} /> */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <button className="textButton" style={{}} onClick={() => { setBrainCategory('') }}> {'<-Back'}</button>
                            <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAddingBrain(true); setEditId(''); setName(''); setPriority(1); setVideo(''); setExcerpt(''); setThumbnail('') }}>+ Add New</button>
                        </div>

                        <h2>{mode} Activities</h2>
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        Name
                                    </th>
                                    <th>
                                        Thumbnail
                                    </th>
                                    <th>
                                        Priority
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {brainActivities.map(({ id, name, video, excerpt, priority, thumbnail }) => <tr key={id}>
                                    <td>
                                        {name}
                                    </td>
                                    <td>
                                        <img src={thumbnail} style={{ height: '150px' }} />
                                    </td>
                                    <td>
                                        {priority}
                                    </td>

                                    <td>
                                        <div style={{ display: 'flex' }}>
                                            <button className="textButton" onClick={() => viewBrainActivityStats({ id, name })}>View</button>
                                            <button className="textButton" onClick={() => { setIsAddingBrain(true); setEditId(id); setPriority(priority); setName(name); setThumbnail(thumbnail); setVideo(video); setExcerpt(excerpt); }}>Edit</button>
                                        </div>
                                    </td>

                                </tr>)}
                            </tbody>
                        </table>
                    </>}

                </> :
                    isAdding ? <>
                        <h2>{`${editId ? 'Edit' : 'Add'} a ${mode} Category`}</h2>
                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Upload icon</label>
                        <MyDropzone storageLocation={`Categories/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={icon} updateImage={(doc) => setIcon(doc)} />

                        <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio</label>
                        <MyDropzone storageLocation={`Categories/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={audio} updateImage={(doc) => setAudio(doc)} />

                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'bg'} value={bg} setValue={setBg} label={'Background'} />
                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'bg'} value={textColor} setValue={setTextColor} label={'Text Color'} />

                        <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={priority} setValue={setPriority} label={'Priority'} />

                        <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                            <button disabled={!name || !bg || !icon || !textColor || !priority || !parseInt(priority)} onClick={saveLearnCategory}>Save</button>
                            <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAdding(false); setEditId('') }}>Cancel</button>
                        </div>
                    </> :
                        <>

                            <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAdding(true); setEditId(''); setName(''); setIcon(''); }}>+ Add New</button>

                            <h2>{mode} Categories</h2>
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Icon
                                        </th>
                                        <th>
                                            Background Color
                                        </th>
                                        <th>
                                            Text Color
                                        </th>
                                        <th>
                                            Priority
                                        </th>
                                        <th>
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parentsCategories.filter(r => mode === 'Center Downloads' ? !r.parentId : true).map(({ id, name, icon, audio, background, priority, textColor }) => <tr key={id}>
                                        <td>
                                            {name}
                                        </td>
                                        <td>
                                            <img src={icon} style={{ width: '100px', height: '100px' }} />
                                        </td>
                                        <td>
                                            {background}
                                        </td>
                                        <td>
                                            {textColor}
                                        </td>
                                        <td>
                                            {priority}
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex' }}>
                                                <button className="textButton" onClick={() => { mode === 'Center Downloads' ? setCenterDownloadCategory(id) : mode === 'Brain' ? setBrainCategory(id) : navigate(`/categories?category=${id}`) }}>View</button>
                                                <button className="textButton" onClick={() => { setIsAdding(true); setPriority(priority); setEditId(id); setName(name); setAudio(audio); setIcon(icon); setBg(background); setTextColor(textColor) }}>Edit</button>
                                            </div>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </>}

    </div>
}

export default Dashboard
